import React, { useState } from 'react'
import { ImageUpload, PreviewImage, theme } from '@clickcease/cc-client-components-lib'
import { UploadFile } from '@clickcease/cc-client-components-lib/dist/types/Files'
import { useGetAccountLogo } from 'Features/accountSettings/api/getAccountLogo'
import { useSetAccountLogo } from 'Features/accountSettings/api/setAccountLogo'
import { useDeleteAccountLogo } from 'Features/accountSettings/api/deleteAccountLogo'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useTranslation } from 'react-i18next'

export const AddLogoImage = () => {
  const { data: initialData } = useGetAccountLogo()
  const deleteLogo = useDeleteAccountLogo()
  const setLogo = useSetAccountLogo()
  const { t } = useTranslation('accountSettings')
  const { showToaster } = useAppStore()

  const [files, setFiles] = useState<Array<UploadFile>>([])
  const [errorMassage, setErrorMassage] = useState('')
  const [validUpload, setValidUpload] = useState<boolean>(false)

  const fileStatus = setLogo.isLoading ? 'loading' : setLogo.isError ? 'error' : 'success'

  const onSubmit = (filesArray: UploadFile[]) => {
    setFiles(filesArray)
    if (filesArray.length) {
      setLogo.mutate(filesArray[0], {
        onSuccess: (data) => {
          if (!data.message) {
            setValidUpload(true)
            showToaster(t('upload_image_notifications.success'), 'success')
          } else {
            setValidUpload(false)
            showToaster(t(`upload_image_notifications.${data.message}`), 'failure')
          }
        },
        onError: () => {
          setValidUpload(false)
          showToaster(t('upload_image_notifications.ERROR_UPLOADING_LOGO_FILE'), 'failure')
        },
      })
    } else deleteLogo.mutate()
  }

  const showInitialPreviewImage =
    !files.length && !!initialData && !(initialData instanceof Error) && !!initialData.downloadLink

  return (
    <div id={'account-settings-logo-tab'}>
      {/*for future reference, there's a previewImage component bundled inside the ImageUpload component*/}
      <ImageUpload
        files={files}
        setFiles={onSubmit}
        errorMassage={errorMassage}
        setErrorMassage={setErrorMassage}
        accept={['image/svg', 'image/png']}
        maxSize={50000}
        fileStatus={!validUpload ? 'error' : fileStatus}
        deleteLoading={deleteLogo.isLoading}
        validUpload={validUpload}
        uploadLoading={setLogo.isLoading}
        style={{
          width: '550px',
          height: '300px',
          maxWidth: '100%',
          marginTop: theme.space['11'].value,
        }}
      />
      {showInitialPreviewImage && (
        <PreviewImage
          src={initialData?.downloadLink}
          onClick={deleteLogo.mutate}
          loading={deleteLogo.isLoading}
        />
      )}
    </div>
  )
}
